import { bnPageHead } from "@/lib/bn-head";
import type { BnLocation, BnServiceCopy } from "@/content/bn/locations";

const NOT_FOUND = {
  meta: [{ title: "পেজ পাওয়া যায়নি" }, { name: "robots", content: "noindex" }],
};

/** Head metadata for a Bangla city hub — /bn/seo-services/$location. */
export function bnCityHead(loc?: BnLocation) {
  if (!loc) return NOT_FOUND;
  return bnPageHead({
    path: `/bn/seo-services/${loc.slug}`,
    enPath: `/seo-services/${loc.slug}`,
    title: `${loc.cityBn}-এ এসইও এক্সপার্ট — লোকাল এসইও সেবা`,
    desc: `${loc.cityBn}, বাংলাদেশের ব্যবসার জন্য লোকাল এসইও, Google Business Profile, টেকনিক্যাল এসইও ও কনটেন্ট কৌশল। স্বচ্ছ রিপোর্টিং, বাস্তব ফল।`,
    keywords: [
      `seo ${loc.slug}`,
      `${loc.cityBn} এসইও`,
      `${loc.cityBn} লোকাল এসইও`,
      `seo expert ${loc.city}`,
    ],
  });
}

/** Head metadata for a Bangla city × service page — /bn/seo-services/$location/$service. */
export function bnCityServiceHead(loc?: BnLocation, svc?: BnServiceCopy, svcSlug?: string) {
  if (!loc || !svc || !svcSlug) return NOT_FOUND;
  return bnPageHead({
    path: `/bn/seo-services/${loc.slug}/${svcSlug}`,
    enPath: `/seo-services/${loc.slug}/${svcSlug}`,
    title: `${loc.cityBn}-এ ${svc.title}`,
    desc: `${loc.cityBn}, বাংলাদেশের ব্যবসার জন্য ${svc.title}। ${svc.tagline} স্বচ্ছ স্কোপ, বাস্তব রিপোর্টিং।`,
    keywords: [`${svcSlug} ${loc.slug}`, `${loc.cityBn} ${svc.title}`, `${loc.cityBn} এসইও সেবা`],
  });
}
